import script from "./GlobalEventView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GlobalEventView.vue?vue&type=script&lang=ts&setup=true"

import "./GlobalEventView.vue?vue&type=style&index=0&id=b8dba91a&lang=scss"

const __exports__ = script;

export default __exports__